import { AsynchronousWrapper, RequirementsTable, TrlRader } from "Components";
import { CasePhaseConstants, LoggingConstants } from "Constants";
import { CasePageEnum, VoteTypeEnum } from "Enums";
import { PendoHelperSingleton } from "Helpers";
import { useFetch } from "Hooks";
import { FC, useContext, useEffect } from "react";
import { CaseContext } from "Stores";
import { TTiOverviewDTO, TUseFetch } from "Types";

type TTiPartialOverviewProps = {
    casePage: CasePageEnum
};

export const TiPartialOverview: FC<TTiPartialOverviewProps> = ({ casePage }: TTiPartialOverviewProps) => {

    // Shared states
    const { caseState } = useContext(CaseContext);

    // We use `useFetch` custom hook here
    // to fetch data from the server
    const { isLoading, didError, errorMessage, fetchedData }: TUseFetch<TTiOverviewDTO> = useFetch(`api/cases/${caseState.selectedCaseId}/requirementsTable/${caseState.casePhase.toLowerCase()}`, [casePage]);

    useEffect(() => {
        PendoHelperSingleton.trackEventWithProperties(`${LoggingConstants.DYNAMIC_DELIVERY}CaseRequirementsTable`, {
            caseId: caseState.selectedCaseId
        });
    }, [caseState.selectedCaseId]);

    return (
        <AsynchronousWrapper didError={didError} errorMessage={errorMessage} isLoading={isLoading} LoaderComponent={null}>
            <>
                {casePage === CasePageEnum.RequiremenstTable ?
                    <RequirementsTable tiOverviewDto={fetchedData} voteType={caseState.casePhase.toLowerCase() === CasePhaseConstants.PHASE_1.toLowerCase() ? VoteTypeEnum.YesNoSuper : VoteTypeEnum.FiveStars} />
                    : null}
                {casePage === CasePageEnum.Radar ?
                    <TrlRader tiOverviewDto={fetchedData} voteType={caseState.casePhase.toLowerCase() === CasePhaseConstants.PHASE_1.toLowerCase() ? VoteTypeEnum.YesNoSuper : VoteTypeEnum.FiveStars} />
                    : null}
            </>
        </AsynchronousWrapper>
    );
};